import { UI } from "@wwimmo/ui";
import { observer } from "mobx-react";
import { useContext } from "react";
import { RootStoreContext } from "src/stores/RootStore";
import styles from "./AttendanceQuorumInfo.module.css";
import { useTranslation } from "react-i18next";

export const AttendanceQuorumInfo = observer(function AttendanceQuorumInfo() {
    const { t } = useTranslation();
    const { attendanceListStore } = useContext(RootStoreContext);
    const areBothQuorumsStatisfied =
        attendanceListStore.quorumHeadInfo.isHeadQuorumSatisfied &&
        attendanceListStore.quorumValueQuotaInfo.isValueQuotaSatisfied;

    const bgColorIconRoot = areBothQuorumsStatisfied ? "#234C11" : "#8A1A10";
    const bgColorTextRoot = areBothQuorumsStatisfied ? "#E8EDE7" : "#F2E7E6";

    const fontWeightHeadQuorum = attendanceListStore.quorumHeadInfo.isHeadQuorumSatisfied ? "normal" : "bold";
    const fontWeightValueQuorum = attendanceListStore.quorumValueQuotaInfo.isValueQuotaSatisfied ? "normal" : "bold";

    const renderContent = () => {
        return (
            <div className={styles.Root}>
                <div className={styles.InfoIconRoot} style={{ backgroundColor: bgColorIconRoot }}>
                    <UI.Icon
                        icon={areBothQuorumsStatisfied ? UI.SVGIcon.Check : UI.SVGIcon.InformationFilled}
                        color={"white"}
                        size={64}
                    />
                </div>
                <div className={styles.TextRoot} style={{ backgroundColor: bgColorTextRoot }}>
                    <span className={styles.Quorum} style={{ color: bgColorIconRoot }}>
                        {areBothQuorumsStatisfied
                            ? t("screens.assemblies.attendance.quorum_valid")
                            : t("screens.assemblies.attendance.quorum_invalid")}
                    </span>
                    <span style={{ color: "black", fontWeight: fontWeightHeadQuorum }}>
                        {`${t("screens.assemblies.attendance.present_headQuotas")} ${
                            attendanceListStore.quorumHeadInfo.presenceLabel
                        }`}
                    </span>
                    <span style={{ color: "black", fontWeight: fontWeightValueQuorum }}>
                        {`${t("screens.assemblies.attendance.present_valueQuotas")} ${
                            attendanceListStore.quorumValueQuotaInfo.valueQuotaLabel
                        }`}
                    </span>
                </div>
            </div>
        );
    };

    if (areBothQuorumsStatisfied) {
        return renderContent();
    }

    return (
        <UI.OverlayTrigger
            flip={true}
            overlay={
                <UI.Tooltip id={"attendanceQuorumInfo-tooltip"} className={styles.Tooltip}>
                    {t("screens.realestate.assembly.assembly_quorum_tooltip")}
                </UI.Tooltip>
            }
        >
            {renderContent()}
        </UI.OverlayTrigger>
    );
});
